import React from "react";
import { Modal, Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./ConfirmationModal.module.scss";
import CustomButton from "../v2/custom-button/CustomButton";
import ChatBubbleIcon from "../icon-components/ChatBubbleIcon";

interface ConfirmationModalProps {
  open: boolean;
  title?: string;
  description?: string;
  onCancel: () => void;
  onConfirm: () => void;
  cancelText?: string;
  confirmText?: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  open,
  title = "Unsaved changes",
  description = "Any changes made will not be saved. Are you sure you want to leave this page?",
  onCancel,
  onConfirm,
  cancelText = "Cancel",
  confirmText = "Leave",
}) => {
  return (
    <Modal open={open} onClose={onCancel} className={styles.modalWrapper}>
      <Box className={styles.modalContent}>
        <IconButton className={styles.closeButton} onClick={onCancel}>
          <CloseIcon fontSize="large" />
        </IconButton>

        <Box mb={2}>
          <ChatBubbleIcon width={60} height={60} />
        </Box>

        <Typography variant="h4" mb={2}>
          {title}
        </Typography>
        <Typography variant="body1" mb={4}>
          {description}
        </Typography>

        <Box className={styles.buttonGroup}>
          <CustomButton
            onClick={onCancel}
            variant="outlined"
            text={cancelText}
          />
          <CustomButton
            onClick={onConfirm}
            variant="contained"
            text={confirmText}
          />
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmationModal;
